import React from 'react'
import Button from '../../components/Button/Button'
import PropTypes from 'prop-types'
import './FooterButton.scss'

class FooterButton extends React.Component {
  state = {
    fixed: true,
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const mainFooter = document.getElementsByTagName('footer')[0]
    const footerPosition = mainFooter.getBoundingClientRect().top
    if (window.innerHeight > footerPosition && this.state.fixed) {
      this.setState({ fixed: false })
    }
    if (window.innerHeight < footerPosition && !this.state.fixed) {
      this.setState({ fixed: true })
    }
  }

  render() {
    const {
      buttonContent,
      buttonLink,
      buttonAction,
      iconName,
      backButtonLink,
      backButtonContent,
    } = this.props

    return (
      <div
        className={`footerButtonContainer ${this.state.fixed ? 'fixed' : ''}`}
      >
        <div
          className={`buttonWrapper${backButtonLink ? ' space-between' : ''}`}
        >
          {backButtonLink && (
            <Button link={backButtonLink} type="secondary">
              {backButtonContent}
            </Button>
          )}
          {buttonAction ? (
            <Button onClick={buttonAction} align="right" iconName={iconName}>
              {buttonContent}
            </Button>
          ) : (
            <Button link={buttonLink} align="right" iconName={iconName}>
              {buttonContent}
            </Button>
          )}
        </div>
      </div>
    )
  }
}

FooterButton.propTypes = {
  buttonContent: PropTypes.string,
  buttonLink: PropTypes.string,
  buttonAction: PropTypes.func,
  iconName: PropTypes.string,
  backButtonContent: PropTypes.string,
  backButtonLink: PropTypes.string,
  transparent: PropTypes.bool,
}
export default FooterButton
